import { AccessibleSvg, AccessibleSvgProps } from "@ui/AccesibleSvg";
import styled from "styled-components";

export const StyledAccessibleSvg = styled(AccessibleSvg)<AccessibleSvgProps>`
    pointer-events: none;
    overflow: visible;
`;
